// src/pages/ShopifyAuth.jsx
import React, { useEffect, useState } from 'react';
import qs from 'qs';

const Shopify = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      const { shop, timestamp, hmac } = qs.parse(
        window.location.search.slice(1)
      );

      if (!shop || !timestamp || !hmac) {
        setError('Missing required query params');
        return;
      }

      // 1) Build message string (sorted, no encoding)
      const message = `shop=${shop}&timestamp=${timestamp}`;

      // 2) Import your secret key into Web Crypto
      const secret = '33c1ccaaa2fe2484542ece0d9d111b50'; 
      const enc = new TextEncoder();
      const key = await window.crypto.subtle.importKey(
        'raw',
        enc.encode(secret),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
      );

      // 3) Sign the message
      const signature = await window.crypto.subtle.sign(
        'HMAC',
        key,
        enc.encode(message)
      );
      // convert ArrayBuffer → hex
      const hashArray = Array.from(new Uint8Array(signature));
      const computed = hashArray
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');

      /* if (computed !== hmac) {
        setError('HMAC verification failed');
        return;
      } */

      // 4) Passed HMAC → generate state & redirect
      const state = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(
        /[018]/g,
        c =>
          (
            Number(c) ^
            (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))
          ).toString(16)
      );
      sessionStorage.setItem('shopify_state', state);

     

      window.location.href = "https://"+shop+"/admin/oauth/authorize?client_id=47ab34b84113c8228dbe633850282bc9&scope=read_orders,write_orders,read_content,write_content,read_customers,write_customers,read_fulfillments,write_fulfillments,read_inventory,write_inventory,read_products,write_products,read_reports,write_reports,&redirect_uri=https://editor.workload.co:5000/auth/shopify/redirect&state=&grant_options[]=value"
    })();
  }, []);

  if (error) {
    return <div style={{ color: 'red' }}>Error: {error}</div>;
  }
  return <div>🔄 Redirecting to Shopify for authorization…</div>;
};

export default Shopify;
